import {History, LocationDescriptor, LocationDescriptorObject, LocationState} from 'history';
import queryString from 'querystring';
import {AuthenticatedUser, UserGroup} from "services/entities/auth";
import RouteURLs from "RouteURLs";

export function getUserDefaultRoute(user: AuthenticatedUser): string {
  if(user.groups.indexOf(UserGroup.Landlord) >= 0) {
    return RouteURLs.LANDLORD_DASHBOARD;
  } else {
    return RouteURLs.DASHBOARD;
  }
}

export function createPreserveQueryHistory(history: History, queryParameters: string|RegExp[]): History {
  const oldPush = history.push, oldReplace = history.replace;
  history.push = (path: LocationDescriptor, state?: LocationState) =>
    oldPush.apply(history, [preserveQueryParameters(history, queryParameters, createLocationDescriptorObject(path, state))]);
  history.replace = (path: LocationDescriptor, state?: LocationState) =>
    oldReplace.apply(history, [preserveQueryParameters(history, queryParameters, createLocationDescriptorObject(path, state))]);
  return history;
}

function isPreservedParameter(param: string, preservedParams: string|RegExp[]) {
  for(const p of preservedParams) {
    if(typeof(p) === 'string') {
      if(p === param) {
        return true;
      }
    } else if(p.test(param)) {
      return true;
    }
  }
  return false;
}

function preserveQueryParameters(history: History, preserve: string|RegExp[], location: LocationDescriptorObject): LocationDescriptorObject {
  let search = history.location.search;
  if(!search) {
    return location;
  } else if(search[0] === '?') {
    search = search.substr(1);
  }
  const currentQuery = queryString.parse(search);
  if(!currentQuery) {
    return location;
  }
  const preservedQuery: { [key: string]: string } = {}
  for (let key of Object.keys(currentQuery)) {
    if(isPreservedParameter(key, preserve)) {
      preservedQuery[key] = currentQuery[key].toString();
    }
  }
  let newSearch = location.search;
  if(newSearch && newSearch[0] === '?') {
    newSearch = newSearch.substr(1);
  }
  if (newSearch) {
    Object.assign(preservedQuery, queryString.parse(newSearch));
  }
  location.search = queryString.stringify(preservedQuery);
  return location
}

function createLocationDescriptorObject(location: LocationDescriptor, state?: LocationState): LocationDescriptorObject {
  if(typeof location === 'string') {
    let url: URL;
    try {
      url = new URL(location, 'http://localhost');
    } catch {
      return {pathname: location, state};
    }
    const search = url.search && url.search[0] === '?' ? url.search.substr(1) : url.search;
    return {pathname: url.pathname, search: search, hash: url.hash, state};
  } else {
    return location;
  }
}